import { useState } from "react";
import { Grid } from "@material-ui/core";
import { LIST_URL_MASTER } from "utils/masters";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import {
  defaultToastError,
  titleModal,
  defaultToastSuccess,
} from "App/utils/helpers";

export const ModalFormKelas = ({ setShowModal, run, formData, setFormData }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const addSirsOnline = async () => {
    return instance2.post(LIST_URL_MASTER.kelas_rs_online.add_kelas_kamar_sirsonline,
    {
      ...formData,
    });
  };

  const updateSirsOnline = () => {
    return instance2.put(LIST_URL_MASTER.kelas_rs_online.update_kelas_kamar_sirsonline,
      {
        ...formData,
      },
      {
        headers: {
          id: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);

    if (formData.name === "" || formData.kodebridgingsirs === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama atau Kode tidak boleh kosong");
      return;
    }

    try {
      if (formData.id === "") {
        const res = await addSirsOnline();

        if (res.status === 200) {
          defaultToastSuccess(res.data?.message);
        } else {
          defaultToastError(res.data?.message);
        }
      } else if (formData.id !== "") {
        const res = await updateSirsOnline();

        if (res.status === 200) {
          defaultToastSuccess(res.data?.message);
        } else {
          defaultToastError(res.data?.message);
        }
      }

      run(!run);
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      setShowModal(false);
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${titleModal(formData.id)} Kelas Kamar Sirs Online`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='kodebridgingsirs'
              label='Kode'
              id='kodebridgingsirs'
              autoFocus={true}
              value={formData.kodebridgingsirs}
              onChange={handleChange("kodebridgingsirs")}
              placeholder='Kode'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='Nama'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Nama'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='remark'
              label='Remark'
              id='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder='Remark'
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};